<template>
    <div class="bg">
        <div class="co">
            <div class="kv">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/kv.png">
            </div>
            <div class="panel">
                <div class="title">
                    <span>选手评分</span>
                </div>
                <div class="hint">
                    <span class="question"></span>
                    <span @click="showPopup">评分规则</span>
                </div>

                <div class="content">
                    <div class="item" :class="item.status==0?'item-disable':'item-enable'" v-for="(item,i) in players" v-bind:key="i">
                        <div class="avatar">
                            <img :src="item.avatar" style="display: block">
                            <span v-if="item.status==1" style="color: red;font-size: 16px;margin-top: 5px;display: block;font-weight: bold">演讲中...</span>
                        </div>
                        <div class="info">
                            <span>{{item.title}}</span>
                            <span>{{item.name}}</span>
                            <span>{{item.hos}}</span>
                            <div class="stars" >
                                <div class="star-item" v-for="(value,index) in item.star" v-bind:key="index" @click="score(i,index,item.player_id)">
                                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/l_star.png" v-if="value==1">
                                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/d_star.png" v-if="value==0">
                                    <span class="l" v-if="value==1">
                                {{index+1}}
                            </span>
                                    <span class="d" v-if="value==0">
                                {{index+1}}
                            </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;height: 100%">
            <MyPopup ref="myPopup" :data="data" :title="title"></MyPopup>
        </div>
    </div>
</template>

<script>
    import "@/assets/iconfont/iconfont.css";
    import MyPopup from "@/components/plugins/popup/MyPopup";
    import {cdqiPlayerListByAudience, cdqiScoreByAudience} from "@/assets/js/api";
    import {openId} from "@/assets/js/api";
    import {isMobile} from "@/assets/util/util";

    export default {
        name: "PlayerScore",
        components:{
          MyPopup
        },
        data(){
            return{
                players:[
                ],
                data:["1、分别由专家打分和观众打分，专家占比95%，观众占比5%","2、专家通过打分表进行打分，观众通过直播端的【选手评分】菜单中进行打分","3、观众只能在选手演讲及点评时间段内进行打分"],
                title:"评分规则",
                appId:null,
                websock:null,
                code:this.$route.query.code,
            }
        },
        methods:{
            score(i,index,playerId){
                this.audienceScore(this.appId,playerId,index,i)
            },
            showPopup(){
                this.$refs.myPopup.popupShow=true
            },
            async list(appId){
                const res = await cdqiPlayerListByAudience({appId})
                this.players = res.data.data
            },
            async audienceScore(appId,playerId,index,i){
                let score = index+1
                const res = await cdqiScoreByAudience({appId,playerId,score})
                if(res.data.success){
                    this.$toast("提交成功")
                    let stars = this.players[i].star;
                    for(let k=0;k<stars.length;k++){
                        if(k<=index){
                            stars[k]=1;
                        }else{
                            stars[k]=0;
                        }
                    }
                    this.players = Object.assign({},this.players)
                }else{
                    this.$toast(res.data.message)
                }
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.2.120:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e.data)
                // var da =e.data;
                this.list(this.appId)
            },
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.appId= res.data.openId;
                    await this.list(this.appId)
                }else{
                    // if(isMobile()){//移动端重定向，把code带回来
                    //     let url = "http://app.iumed.com.cn/hz/ps"
                    //     window.location.replace("http://tang.iumed.com.cn?url="+url)
                    // }
                }
            },

        },
        mounted(){
            // 获取openid
            if(this.code!=null){
                this.getOpenId(this.code)
            }else{
                if(isMobile()){//移动端重定向，把code带回来
                    let url = "http://app.iumed.com.cn/hz/ps"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }else{
                    this.appId= "123";
                    this.list(this.appId)
                }
            }

            this.initWebSocket();//初始化websocket
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/bg-2.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
    }
    .co{
        position: absolute;
    }
    .kv{
        width: 100%;
        img{
            width: 100%;
            height: auto;
            margin-top: 10px;
        }
    }
    .panel{
        position: absolute;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/panel.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .panel .title{
        margin-top: 3%;
        width: 100%;
        height: 20px;
        font-size: 14px;
        color: #FFF;

    }
    .panel .hint{
        position: absolute;
        right: 4%;
        top: 2%;
        font-weight: bold;
        font-size: 11px;
        text-align: right;
        display: flex;
        align-items: center;
        color: #FFF;
    }
    .question{
        width: 12px;
        height: 12px;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/question-circle.png") no-repeat;
        background-size: 100% 100%;
        display: inline-block;margin-right: 3px;
    }
    .content{
        flex-grow: 1;
        background: #FFF;
        width: 96%;
        margin-top: 4%;
        margin-bottom: 1%;
        border-radius: 10px;
        overflow: scroll;
    }
    .item{
        display: flex;
        flex-direction: row;
        padding: 10px 0 0 0;
        border-bottom: 1px solid #e5e5e5;
        .avatar{
            margin: 0px 10px 0 10px;

             img{
                 width: 70px;
                 height: 70px;
                 border-radius: 50%;
             }
        }
        .info{
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            font-size: 14px;
            flex-grow: 1;
            margin-right: 0px;
            span{
                display: block;
                text-align: left;
                margin-bottom: 2px;
            }
            span:first-child{
                font-weight: bold;
            }
        }
        .stars{
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
        }
        .star-item{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 8px;
            cursor: pointer;
            border: none;
            outline: none;
            img{
                width: 15px;
                height: auto;
            }
        }
        .star-item:last-child{
            margin-right: 10px;
        }
        .l{
            color: #000;
            margin-top: 5px;
        }
        .d{
            color: #999;
            margin-top: 5px;
        }
    }

    .item-disable{
        background: #d3d2d2;
    }
    .item-enable{
        background: #e5f2e0;
    }

</style>